export enum ApprovalAction {
  approve = "approve",
  reject = "reject",
  cancel = "cancel",
}
